const URL = `https://api.monkey-adventurekart.com/api`;
export const FileUrl = `https://www.monkey-adventurekart.com/`;
export const BaseUrl = `https://api.monkey-adventurekart.com/public/`;
export const BlogImageUrl = `${BaseUrl}/blog`;

export const getasakusa = {
  method: "GET",
  url: `${URL}/home/asakusa`,
};

export const getShibuya = {
  method: "GET",
  url: `${URL}/home/shibuya`,
};

export const getShinagawa = {
  method: "GET",
  url: `${URL}/home/shinagawa`,
};

export const getShinjuku = {
  method: "GET",
  url: `${URL}/home/shinjuku`,
};

export const getOsaka = {
  method: "GET",
  url: `${URL}/home/osaka`,
};

export const getMtfuji = {
  method: "GET",
  url: `${URL}/home/mtfuji`,
};

export const getHelicopter = {
  method: "GET",
  url: `${URL}/home/helicopter`,
};

export const getTour = {
  method: "POST",
  url: `${URL}/home/getTour`,
};

export const getTiming = {
  method: "POST",
  url: `${URL}/home/getTime`,
};

export const getBooking = {
  method: "POST",
  url: `${URL}/book/booking`,
};

export const applyCoupon = {
  method: "POST",
  url: `${URL}/home/applyCoupon`,
};

export const verifyStripePayment = {
  method: "GET",
  url: `${URL}/book/stripe/verify`,
};

export const getBookingApi = {
  method: "GET",
  url: `${URL}/home/BookingApi`,
};

export const getBlogs = {
  method: "GET",
  url: `${URL}/blog/blogs`,
};

export const getBlogDetail = {
  method: "GET",
  url: `${URL}/blog`,
};

export const SendEnquiry = {
  method: "POST",
  url: `${URL}/home/sendenquiry`,
};

export const JDMenquiry = {
  method: "POST",
  url: `${URL}/home/Jdmenquiry`,
};

export const vipTour = {
  method: "POST",
  url: `${URL}/home/vip-tour`,
};

export const getAbout = {
  method: "GET",
  url: `${URL}/home/about`,
};
export const getContact = {
  method: "GET",
  url: `${URL}/home/contact`,
};

export const getFaq = {
  method: "GET",
  url: `${URL}/home/faq`,
};

export const getOptions = {
  method: "GET",
  url: `${URL}/home/options`,
};

export const getDrivingLicense = {
  method: "GET",
  url: `${URL}/home/driving-license`,
};

export const getSpecifications = {
  method: "GET",
  url: `${URL}/home/specifications`,
};

export const getBook1 = {
  method: "GET",
  url: `${URL}/home/book1`,
};

export const cancelStripePayment = {
  method: "GET",
  url: `${URL}/book/stripe/cancel-verify`,
};


export const verifyPaypalPayment = {
  method: "GET",
  url: `${URL}/book/paypal/verify`,
};

export const cancelPaypalPayment = {
  method: "GET",
  url: `${URL}/book/paypal/cancel-verify`,
};
// --------------------Admin api ---------------------

export const login = {
  method: "POST",
  url: `${URL}/auth/login`,
};

export const dashboardData = {
  method: "GET",
  url: `${URL}/auth/dashboard-data`,
};

export const bookingsList = {
  method: "POST",
  url: `${URL}/auth/bookings`,
};

export const contactList = {
  method: "GET",
  url: `${URL}/auth/contacts`,
};

export const jdmList = {
  method: "GET",
  url: `${URL}/auth/Jdm`,
};

export const couponList = {
  method: "GET",
  url: `${URL}/auth/coupons`,
};

export const dropdownData = {
  method: "GET",
  url: `${URL}/auth/dropdown-data`,
};

export const createManualBooking = {
  method: "POST",
  url: `${URL}/auth/create-booking`,
};

export const deleteContact = {
  method: "POST",
  url: `${URL}/auth/delete-contact`,
};

export const deleteJdm = {
  method:"POST",
  url:`${URL}/auth/delete-jdm`
}
export const getCategory = {
  method: "POST",
  url: `${URL}/auth/get-category`,
};

export const getBookingDetail = {
  method: "GET",
  url: `${URL}/auth/booking`,
};

export const updateBooking = {
  method: "PUT",
  url: `${URL}/auth/update-booking`,
};

export const deleteBooking = {
  method: "POST",
  url: `${URL}/auth/delete-booking`,
};

export const getVipRequests = {
  method: "GET",
  url: `${URL}/auth/get-vip-requests`,
};

export const deleteVipRequest = {
  method: "POST",
  url: `${URL}/auth/delete-vip-request`,
};

export const getInventory = {
  method: "POST",
  url: `${URL}/auth/get-inventory`,
};

export const updateInventory = {
  method: "POST",
  url: `${URL}/auth/update-inventory`,
};

export const createCoupon = {
  method: "POST",
  url: `${URL}/auth/create-coupon`,
};

export const deleteCoupon = {
  method: "POST",
  url: `${URL}/auth/delete-coupon`,
};

export const updateCouponStatus = {
  method: "POST",
  url: `${URL}/auth/update-coupon-status`,
};

export const adminBlogList = {
  method: "GET",
  url: `${URL}/auth/blogs`,
};

export const deleteBlog = {
  method: "POST",
  url: `${URL}/auth/delete-blog`,
};

export const createBlog = {
  method: "POST",
  url: `${URL}/auth/create-blog`,
};

export const adminBlogDetail = {
  method: "GET",
  url: (id) => `${URL}/auth/blog-detail/${id}`,
};

export const updateBlog = {
  method: "POST",
  url: (id) => `${URL}/auth/update-blog/${id}`,
};

export const backupDatabase = {
  method: "GET",
  url: `${URL}/auth/backup-database`,
};
export const mtFujiBookingsList = {
  method: "POST",
  url: `${URL}/auth/mtfuji-bookings`,
};

export const resendEmail = {
  method: "POST",
  url: `${URL}/auth/resend-booking-email`,
};
export const getjdmtour = {
  method: "GET",
  url: `${URL}/home/jdmtour`,
};


export const getRainbow = {
  method: "GET",
  url: `${URL}/home/rainbow`,
};


export const getDiscDays = {
  method: "POST",
  url: `${URL}/home/getDiscDays`,
};